'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _propTypes3 = require('../propTypes'),
    _themes = require('../themes');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var withCommonProps = function withCommonProps(WrappedComponent) {
  var WithCommonProps = function (_React$Component) {
    function WithCommonProps() {
      return _classCallCheck(this, WithCommonProps), _possibleConstructorReturn(this, (WithCommonProps.__proto__ || Object.getPrototypeOf(WithCommonProps)).apply(this, arguments));
    }

    return _inherits(WithCommonProps, _React$Component), _createClass(WithCommonProps, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            dir = _props.dir,
            inheritStyles = _props.inheritStyles,
            lang = _props.lang,
            theme = _props.theme,
            i18n = theme.vstui.i18n,
            commonProps = {};
        return inheritStyles ? (dir && (commonProps.dir = dir), lang && (commonProps.lang = lang)) : (commonProps.dir = dir || i18n.direction, commonProps.lang = lang || i18n.locale), _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
          commonProps: commonProps
        }));
      }
    }]), WithCommonProps;
  }(_react2.default.Component);

  return WithCommonProps.propTypes = {
    dir: _propTypes2.default.oneOf(['ltr', 'rtl', 'auto']),
    inheritStyles: _propTypes2.default.bool,
    lang: _propTypes2.default.string,
    theme: _propTypes3.themeShape
  }, WithCommonProps.defaultProps = {
    theme: (0, _themes.createTheme)()
  }, WithCommonProps.displayName = 'WithCommonProps(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', (0, _themes.withTheme)(WithCommonProps);
};

exports.default = withCommonProps;